import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "volunteer-signup-view" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = {
  key: 0,
  class: "success-message"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}
const _hoisted_5 = { class: "form-section" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "form-group full-width" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-section" }
const _hoisted_12 = { class: "skills-checkboxes" }
const _hoisted_13 = { class: "checkbox-label" }
const _hoisted_14 = { class: "checkbox-label" }
const _hoisted_15 = { class: "checkbox-label" }
const _hoisted_16 = { class: "checkbox-label" }
const _hoisted_17 = { class: "form-section" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-actions" }
const _hoisted_20 = ["disabled"]

import { ref } from 'vue'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'VolunteerSignupView',
  setup(__props) {

const formData = ref({
  name: '',
  email: '',
  phone: '',
  interested_in: [] as string[],
  comments: ''
})

const submitting = ref(false)
const successMessage = ref('')
const errorMessage = ref('')

const submitSignup = async () => {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''

  try {
    const response = await axios.post('/api/v1/volunteers/signup', formData.value)

    successMessage.value = response.data.message || 'Thank you for signing up! We will contact you about volunteer opportunities.'

    // Reset form
    formData.value = {
      name: '',
      email: '',
      phone: '',
      interested_in: [],
      comments: ''
    }

    // Scroll to top to show success message
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (error: any) {
    console.error('Error submitting volunteer signup:', error)
    errorMessage.value = error.response?.data?.detail || 'Failed to submit signup. Please try again.'
  } finally {
    submitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-header" }, [
        _createElementVNode("h1", null, "Volunteer With Us"),
        _createElementVNode("p", null, "Join our team of volunteers helping provide technology access to students")
      ], -1)),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(successMessage.value), 1))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (!successMessage.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _withModifiers(submitSignup, ["prevent"]),
            class: "volunteer-form"
          }, [
            _createElementVNode("section", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Contact Information", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { for: "name" }, "Full Name *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                    type: "text",
                    required: "",
                    placeholder: "Enter your full name"
                  }, null, 512), [
                    [_vModelText, formData.value.name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { for: "email" }, "Email *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                    type: "email",
                    required: "",
                    placeholder: "your-email@example.com"
                  }, null, 512), [
                    [_vModelText, formData.value.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "phone" }, "Phone", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "phone",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event)),
                    type: "tel",
                    placeholder: "(321) 555-1234"
                  }, null, 512), [
                    [_vModelText, formData.value.phone]
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("h2", null, "How Would You Like to Help?", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "section-description" }, "Select any areas where you'd like to volunteer (optional)", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: "computer_refurbishment",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.interested_in) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.interested_in]
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "skill-info" }, [
                    _createElementVNode("span", { class: "skill-label" }, "Computer Refurbishment"),
                    _createElementVNode("span", { class: "skill-description" }, "Help refurbish, repair, and prepare computers for distribution")
                  ], -1))
                ]),
                _createElementVNode("label", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: "distribution_delivery",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.interested_in) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.interested_in]
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "skill-info" }, [
                    _createElementVNode("span", { class: "skill-label" }, "Distribution/Delivering"),
                    _createElementVNode("span", { class: "skill-description" }, "Assist with delivering laptops to students and schools")
                  ], -1))
                ]),
                _createElementVNode("label", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: "stem_mentoring",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.interested_in) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.interested_in]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "skill-info" }, [
                    _createElementVNode("span", { class: "skill-label" }, "STEM Mentoring"),
                    _createElementVNode("span", { class: "skill-description" }, "Mentor students in technology and STEM-related areas")
                  ], -1))
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: "stem_workshops",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.interested_in) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.interested_in]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "skill-info" }, [
                    _createElementVNode("span", { class: "skill-label" }, "STEM Workshops/Career Days"),
                    _createElementVNode("span", { class: "skill-description" }, "Help organize and participate in workshops and career day events")
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_17, [
              _cache[19] || (_cache[19] = _createElementVNode("h2", null, "Additional Information", -1)),
              _createElementVNode("div", _hoisted_18, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "comments" }, "Comments", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "comments",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.comments) = $event)),
                  rows: "4",
                  placeholder: "Tell us about your availability, interests, or anything else you'd like us to know..."
                }, null, 512), [
                  [_vModelText, formData.value.comments]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "submit",
                disabled: submitting.value,
                class: "btn-submit"
              }, _toDisplayString(submitting.value ? 'Submitting...' : 'Sign Up to Volunteer'), 9, _hoisted_20)
            ])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})